
import { BooleanNotation, DateTimeNotation, DecimalNotation, ExportLayout } from 'libs/enums.js';
import { i18n } from '@/localize';

export const booleanNotation = [
  {
    text: i18n.t('exportdialog.booleannotation.truefalse'),
    value: BooleanNotation.TrueFalse
  },
  {
    text: i18n.t('exportdialog.booleannotation.yesno'),
    value: BooleanNotation.YesNo
  },
  {
    text: i18n.t('exportdialog.booleannotation.tf'),
    value: BooleanNotation.TF
  },
  {
    text: i18n.t('exportdialog.booleannotation.yn'),
    value: BooleanNotation.YN
  },
  {
    text: i18n.t('exportdialog.booleannotation.onezero'),
    value: BooleanNotation.OneZero
  }
];

export const decimalNotation = [
  {
    text: i18n.t('exportdialog.decimalnotation.comma'),
    value: DecimalNotation.Comma
  },
  {
    text: i18n.t('exportdialog.decimalnotation.dot'),
    value: DecimalNotation.Dot
  }
];

export const exportLayout = [
  {
    text: i18n.t('exportdialog.exportlayout.importlayout'),
    value: ExportLayout.ImportLayout
  },
  {
    text: i18n.t('exportdialog.exportlayout.gridlayout'),
    value: ExportLayout.GridLayout
  }
];

export const exportGridLayout = [
  {
    text: i18n.t('exportdialog.exportlayout.gridlayout'),
    value: ExportLayout.GridLayout
  }
];

export const exportImportLayout = [
  {
    text: i18n.t('exportdialog.exportlayout.importlayout'),
    value: ExportLayout.ImportLayout
  }
];

export const dateTimeNotation = [
  {
    text: i18n.t('exportdialog.datetimenotation.dmyyyy'),
    value: DateTimeNotation.DMYYYY
  },
  {
    text: i18n.t('exportdialog.datetimenotation.dmyyyy_dash'),
    value: DateTimeNotation.DMYYYY_Dash
  },
  {
    text: i18n.t('exportdialog.datetimenotation.ddmmyyyy'),
    value: DateTimeNotation.DDMMYYYY
  },
  {
    text: i18n.t('exportdialog.datetimenotation.mdyyyy'),
    value: DateTimeNotation.MDYYYY
  },
  {
    text: i18n.t('exportdialog.datetimenotation.mdyyyy_dash'),
    value: DateTimeNotation.MDYYYY_Dash
  },
  {
    text: i18n.t('exportdialog.datetimenotation.mmddyyyy'),
    value: DateTimeNotation.MMDDYYYY
  }
];